import { AssetDto } from '@/shared/lib/sj-orm/models/asset.dto';

export const getAssetRelatedFilePaths = (
  asset: AssetDto & { attachments?: string[]; receipt?: string[]; photo?: string[] },
) => {
  const filePaths = [asset.attachments, asset.receipt, asset.photo]
    .flat()
    .filter((filePath) => filePath !== undefined);

  return filePaths;
};
